import { Modal, Button, Card, Badge } from 'react-bootstrap';
import type { Manual } from '../../../infrastructure/ManualClient';
import { formatDate } from '../../../utils/dateUtils';

interface ManualDetailModalProps {
  show: boolean;
  manual: Manual;
  onHide: () => void;
  onEdit: () => void;
}

export const ManualDetailModal = ({ show, manual, onHide, onEdit }: ManualDetailModalProps) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Manual Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <h3>{manual.title}</h3>
          <div className="text-muted mb-2">Last updated: {formatDate(manual.updateAt)}</div>
          <div className="mb-3">
            <h5>Overview</h5>
            <p style={{ whiteSpace: 'pre-line' }}>{manual.overview}</p>
          </div>
          {manual.comment && (
            <div className="mb-3">
              <h5>Comment</h5>
              <p style={{ whiteSpace: 'pre-line' }}>{manual.comment}</p>
            </div>
          )}
        </div>

        <h5 className="mb-3">
          Sequences <Badge bg="info">{manual.sequences.length} steps</Badge>
        </h5>

        {manual.sequences.map((sequence, index) => (
          <Card key={index} className="mb-3">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <Badge bg="primary" className="me-2">
                  Step {sequence.sequenceIndex + 1}
                </Badge>
              </div>
            </Card.Header>
            <Card.Body>
              <h6>Instruction</h6>
              <p style={{ whiteSpace: 'pre-line' }}>{sequence.instruction}</p>

              <h6>Example</h6>
              <p style={{ whiteSpace: 'pre-line' }}>{sequence.example}</p>
            </Card.Body>
          </Card>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onEdit}>
          Edit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
